/**
 * Отказы, у которых есть свой разбор, — не сбой, и общий красный тост их не показывает.
 *
 * Гейт захода 6 (обе половины, MAJOR): `MODULE_FORBIDDEN` — решение матрицы доступа, у него свой
 * экран (`ModuleGuard`) и своё действие («Запросить доступ»); тост «Ошибка загрузки» с trace-id
 * дублировал экран стопкой по каждому фоновому запросу.
 *
 * С-I3 Р.1, круг 1 гейта (UI, MAJOR): `ENTITY_FORBIDDEN` (членство в компании отключили посреди
 * сессии) разбирает обработчик провайдера — сессия переходит в другую компанию с одним спокойным
 * тостом или на вход с причиной.
 *
 * Код приезжает ВЛОЖЕННЫМ: конверт `{"code":"auth.forbidden","details":{"code":"MODULE_FORBIDDEN",…}}`
 * — внешний код общий для всех отказов, конкретику несёт `details.code`. Первая редакция проверки
 * читала внешний код и не гасила ничего (проверено живым ответом стенда).
 */
import { ApiRequestError } from './client';
import { isEntityForbidden } from './entity-forbidden';

export function isModuleForbidden(err: unknown): boolean {
  if (!(err instanceof ApiRequestError) || err.status !== 403) return false;
  const inner = (err.details as { code?: unknown } | undefined)?.code;
  return err.code === 'MODULE_FORBIDDEN' || inner === 'MODULE_FORBIDDEN';
}

export function isAccessDecision(err: unknown): boolean {
  return isModuleForbidden(err) || isEntityForbidden(err);
}
